import { Link } from "react-router-dom";

const ApplicationsClosedMessage = () => (
  <div className="text-center c-lg:w-[400px]">
    <p className="text-xl">Applications Closed</p>
    <p>
      Applications have now officially closed, but stay tuned for program
      updates and future opportunities by{" "}
      <Link to="/signup" className="text-red hover:underline">
        creating an account
      </Link>
      .
    </p>
  </div>
);

export default ApplicationsClosedMessage;
